import { render, staticRenderFns } from "./video-play.vue?vue&type=template&id=623ba8ba&scoped=true&"
import script from "./video-play.vue?vue&type=script&lang=js&"
export * from "./video-play.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623ba8ba",
  null
  
)

export default component.exports